import filter from 'lodash/filter'

export const EMAIL_MAX_LENGTH = 100

export const EMAIL_PATTERN = /^\w+([+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,63})+$/

export const sanitizeEmail = (email: string): string => {
  return email.trim()
}

export const isValidEmail = (email: string): boolean => {
  const sanitized = sanitizeEmail(email)
  return (
    sanitized.length > 0 &&
    sanitized.length <= EMAIL_MAX_LENGTH &&
    EMAIL_PATTERN.test(sanitized)
  )
}

export const filterInvalidEmails = (emails: string[]): string[] => {
  return filter(emails, e => !isValidEmail(e))
}
